// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__h3Qot","inputWrap":"CustomTip_inputWrap__2tz9s"};